import { ReducerAction, State } from '../'
import { Post } from '../interfaces/types'

export enum PostActions {
  update = 'update-post',
  remove = 'remove-post',
  updateMultiple = 'updateMultiple-post',
}

export function postReducer(state: State, action: ReducerAction) {
  switch (action.type) {
    case PostActions.update: {
      const { ignoreNotFound, id, data } = action.payload
      if (!id && !data.id) return state
      const _id = id || data.id

      if (ignoreNotFound && !state.postsById[_id]) return state
      return {
        ...state,
        postsById: {
          ...state.postsById,
          [_id]: {
            ...state.postsById[_id],
            ...(typeof data === 'function' ? data(state.postsById[_id]) : data),
          },
        },
      }
    }
    case PostActions.updateMultiple: {
      const { ignoreNotFound, dataArr = [] } = action.payload
      const { postsById } = state
      dataArr.forEach((data: Post) => {
        if (!data.id) return
        if (ignoreNotFound && !postsById[data.id]) return state
        postsById[data.id] = {
          ...postsById[data.id],
          ...data,
        }
      })
      return {
        ...state,
        postsById: {
          ...postsById,
        },
      }
    }
    case PostActions.remove: {
      const { id } = action.payload
      if (!id) return state
      const { postsById } = state
      delete postsById[id]
      return {
        ...state,
        postsById: {
          ...postsById,
        },
      }
    }
    default: {
      return state
    }
  }
}
